import React, { Component }         from 'react';
import {connect}                    from 'react-redux';
import { Field, reduxForm, reset ,change}  from 'redux-form';
import moment                       from 'moment';
import {Redirect}                   from 'react-router-dom';
import $                            from 'jquery';
import validate                     from '../../../service/validate_tarefas';
import renderDatePicker             from '../../../container/renderDatePicker';
import renderFieldTextArea          from '../../../container/renderFieldTextArea';
import renderField                  from '../../../container/renderField';
import renderFieldRadio             from '../../../container/renderFieldRadio';
import renderCheckbox               from '../../../container/renderFieldCheckBox';
import renderFiles                  from '../../../container/renderFiles';
import {SetError}                   from '../../../actions/notificacaoAction';
import { SetCadastroTarefas,
         SetUploadFilesMidia,
         SetUploadFiles,
         GetTurmasCoordenador,
         GetDisciplinasPerfil
        }      from '../../../actions/tarefaAction';
import FlashRetornoNulo             from '../../../container/FlashRetornoNulo';
import FlashCarregando              from '../../../container/FlashCarregando';
import { SetValidUrlYoutube,
         ClearUrl
        }         from '../../../actions/turmaAction';
import { GetListaMenuTopo,
         GetListaSubMenuTopo}       from '../../../actions/scopoAction';


class TarefaProfessorCadastro extends Component {

    constructor(props){
        super(props);
        this.state = {
                        load: false,
                        loadTurmaSemestre: false,
                        lista: [],
                        listaFilesMidias: [],
                        listaFilesAnexos: [],
                        use_id: this.props.session.id,
                        dataInicio: moment(),
                        dataFim: moment(),
                        dataEntrega: moment(),
                        habilitarFim: true,
                        habilitarEntrega: true,
                        habilitarSemestre: true,
                        habilitarTurma: true,
                        statusCheckEquipe: "",
                        turma: 0,
                        retorno_id: [],
                        tar_id: 0,
                        dis_id: this.props.match.params.id,
                        redirect: false,
                        buttonDisabled: false,
                        content: 'content',
                        options_midia: [
                            { "op": 0, "opcao": 'Nenhuma' },
                            { "op": 1, "opcao": 'Imagem' },
                            { "op": 2, "opcao": 'Vídeo' }
                        ],
                        opcao_tipo_midia: 0,
                        options_flag_equipe: [
                            { "op": 1, "opcao": 'sim' },
                            { "op": 0, "opcao": 'não' }
                        ],
                        opcao_flag_equipe: 0,
                        uploadMidia: 0,
                        fileMidia: '',
                        valMax: 80,
                        countDinamic: 80,
                        valMaxContexto: 400,
                        countDinamicContexto: 400,
                        valMaxObjetivo: 200,
                        countDinamicObjetivo: 200,
                        valMaxRecompensa: 40,
                        countDinamicRecompensa: 40,

                    }
                    this.onChangeVideo = this.onChangeVideo.bind(this);
    }
   
    componentWillMount() {
      
        this.props.GetDisciplinasPerfil(this.props.session.id,"").then((reponse) =>{
            this.setState({load:true});
          }).catch((error)=>{
            this.props.SetError(500);
          });

        this.props.GetListaMenuTopo([
            {action:true,nome:"Home",link:this.props.menu.home},
            {action:true,nome:"Disciplinas",link:this.props.menu.missao.home},
            {action:false,nome:'Missão'},
            {action:false,nome:'Cadastro'},
           ]);

        this.props.GetListaSubMenuTopo([]);

        this.props.initialize({
                                flag_equipe:"0",
                                tar_flag_resposta:"0",
                                tipo_midia:"0" 
                               });

    }

    loadListUpload(dados){
           const list = dados.file;
           const funcao = dados.funcao;
         return  list.map((elem,i) =>{
                return <div className="uploadFileSelect" key={i}>
                            <span className="pull-left"><span className={dados.icon}></span> {elem.name}</span>
                            <span className="pull-right">
                                <button onClick={funcao.bind(this,i)} className="btn btn-link btn-xs">x</button>
                            </span>
                        </div>;
            });
         
         
    }

    onDrop(files) {
       
         if(files.length ===0){
             alert('Formato do arquivo não é suportado.');
         }else{
            const retorno =  this.loadListUpload({file:files,nome:'Documento',icon:'glyphicon glyphicon-file',funcao:this.resetUpload});
            this.setState({selectUpload:1,filesDocumento:files, selectFiles:retorno});
        }
      
    }

    onDropMidia(files) {
              
    //    if(files.length ===0){           
    //        alert('O arquivo selecionado ultrapassou o limite permitido(2mb)');
    //        this.props.dispatch(change('tarefa_form', 'tipo_midia', "0"));
    //    }else{
         const retorno =  this.loadListUpload({file:files,nome:'Mídia',icon:'glyphicon glyphicon-picture',funcao:this.resetUploadMidia});
         this.setState({uploadMidia: 1, fileMidia: files , selectFilesMidia:retorno});
    //   }
            
    }

    onOpenClickMidia(id) {

        this.props.SetUploadFilesMidia(id,this.state.fileMidia).then((response) =>{
            alert("Ação realizada com sucesso!");
            this.setState({Redirect:true})
        }).catch((error) =>{
            this.props.SetError(500);
        });
    }
   
    resetUpload(val){
     
        Array.prototype.remove = function(start, end) {
          this.splice(start, end);
          return this;
        }
        this.state.filesDocumento.remove(val, 1);
       // this.loadListUpload(this.state.files);
        this.setState({selectFiles:null});

    }

    resetUploadMidia(val){     
        Array.prototype.remove = function(start, end) {
          this.splice(start, end);
          return this;
        }
        this.state.fileMidia.remove(val, 1);
       // this.loadListUpload(this.state.files);
        this.setState({selectFilesMidia:null});

    }

    dataInicioChange(e){
      this.setState({dataInicio:moment(e, 'YYYY-MM-DD', true),habilitarFim:false})
    }
    
    dataFimChange(e){
      this.setState({dataFim:moment(e,'YYYY-MM-DD', true),habilitarEntrega:false})
    }
    
    dataEntregaChange(e){
      this.setState({dataEntrega:moment(e,'YYYY-MM-DD', true)})
    }

    handleSubmit(e){
     
         let dados = {   
                         tar_titulo              : e.titulo,
                         tar_descricao           : e.descricao,
                         tar_objetivo            : e.objetivo,
                         tar_txt_recompensa      : e.txt_recompensa,
                         tar_data_inicio         : moment(this.state.dataInicio).format('YYYY-MM-DD'),
                         tar_data_fim            : moment(this.state.dataFim).format('YYYY-MM-DD'),
                         tar_tipo_midia          : e.tipo_midia,
                         tar_flag_resposta       : e.tar_flag_resposta,
                         tar_midia               : e.tipo_midia == '0' ? null : (e.tipo_midia==1 ?e.tar_midia[0]: this.props.ClearUrl(e.tar_midia)),
                         tar_cod_usuario         : this.state.use_id,
                         tar_id                  : this.state.tar_id,
                         tar_flag_entrega_equipe : e.flag_equipe,
                         tar_cod_dis_tur         : e.tar_cod_dis_tur,
                         tar_anexo               : (e.tar_file? e.tar_file[0] : null)
                      }
                  
          this.props.SetCadastroTarefas(dados).then((response) =>{

             alert("Ação realizada com sucesso!");
             this.setState({Redirect:true})

         }).catch((error) =>{
         //   this.props.SetError(500);
         });
 
    }

    onChangeVideo(e) {
       
        const retValid =  this.props.SetValidUrlYoutube(e.target.value);
        this.setState({ 
                        video     : (retValid === 1 ?  e.target.value:""),
                       // validMov  : (retValid === 1 ? false:true),
                        post_tipo : (retValid === 1 ? 3:1),
                        buttonDisabled:(retValid === 1 ? false:true)
                      }); 
  
        if (retValid) {
             $('.valid-url').html("");
        }else{
            this.props.dispatch(change('tarefa_form', 'tar_midia', "0"));
            $('.valid-url').html('<span class="text-danger"><b>Copie e cole uma url válida do Youtube.</b> </span>');         
        }
       
    }

    addCampoMidia(ev){
        var obj = {};

        switch (parseInt(ev.target.value)) {
            case 0:
               obj.midia = "";
               this.setState({ selectFilesMidia: []});
               this.props.dispatch(change('tarefa_form', 'tar_midia', ""));
            break;

            case 1:
              obj.midia = <Field 
                              label="Imagem" 
                              textField="Selecionar imagem..." 
                              component={renderFiles}                              
                              name="tar_midia"  
                              accept="image/jpeg, image/png" 
                              funcao={this.onDropMidia.bind(this)}/>;
            break;

            case 2:
              obj.midia = <div><Field label="Adicionar vídeo do Youtube" name="tar_midia" className="form-control" onChange= {this.onChangeVideo}  component={renderField} /><div className="valid-url"></div></div>;
              this.setState({ selectFilesMidia: []}); 
              this.props.dispatch(change('tarefa_form', 'tar_midia', ""));
            break;
        
            default:
            break;
        }
    
         this.setState({ opcao_tipo_midia: ev.target.value, 
                         midia: obj.midia,
                         buttonDisabled:(parseInt(ev.target.value)==1?false:true)
                      });

    }

    addCampoSelecaoResposta(ev){
      this.setState({tar_flag_resposta: ev.target.value })
    }
 
    renderListaTurmas(){
      
        const disciplina = this.props.all_equipe_disciplina;
        if (disciplina.length>0) {
            const retorno = disciplina.map((elem,i)=>{
                return <div className="list-group-item listaTurmas"  key={i++}>
                         <Field name="tar_cod_dis_tur" 
                            label={`${elem.cur_nome} - ${elem.tur_nome} - ${elem.dis_nome}`} 
                            itemValue={`${elem.dis_pro_cod_disciplina}#${elem.tur_id}`}  
                            component={renderCheckbox}
                            />
                      </div>;
            });
            return <div className="list-group">
                        <a href="#" className="list-group-item disabled"><b>Disciplina</b></a>
                        {retorno}
                    </div>;
        } else {
            return <FlashRetornoNulo/>;
        }
    }

    countCaractere(e){
        const text_remaning = this.state.valMax - e.target.textLength;
        this.setState({countDinamic:text_remaning})
    }

    countCaractereContexto(e){

        const text_remaning = this.state.valMaxContexto - e.target.textLength;
        this.setState({countDinamicContexto:text_remaning})
    }

    countCaractereObjetivo(e){

        const text_remaning = this.state.valMaxObjetivo - e.target.textLength;
        this.setState({countDinamicObjetivo:text_remaning})
    }

    countCaractereRecompensa(e){

        const text_remaning = this.state.valMaxRecompensa - e.target.textLength;
        this.setState({countDinamicRecompensa:text_remaning})
    }

    checkActionEquipe(e){
        const val = e.target.value;
        this.setState({statusCheckEquipe:(parseInt(val)===1? <div className='form-group'><div className='alert alert-info' role='alert'>Certifique-se de que todos os alunos nas turmas selecionadas estejam em uma equipe</div></div>:"")});
    }

    render() {

        if (this.state.Redirect) {
           return (<Redirect to={`${this.props.menu.missao.home}`}/>);
        }

        const {handleSubmit} = this.props;
        
        return (
            <div className="container-bg">
                <div className="panel panel-azul-claro">
                    <div className="panel-body">
                        <form onSubmit={handleSubmit(this.handleSubmit.bind(this))}>
                            <span className="count pull-right">{this.state.countDinamic && this.state.countDinamic}</span>
                            <Field name="titulo" label="Título*" length={this.state.valMax} onChange={this.countCaractere.bind(this)} component={renderFieldTextArea}/>
                           
                            <div className="row">
                                <div className="col-md-6">
                                <span className="count pull-right">{this.state.countDinamicContexto && this.state.countDinamicContexto}</span>
                                <Field name="descricao" label="Contexto*" length={this.state.valMaxContexto} onChange={this.countCaractereContexto.bind(this)} component={renderFieldTextArea} type="textarea" />
                                </div>
                                <div className="col-md-6">
                                <span className="count pull-right">{this.state.countDinamicObjetivo && this.state.countDinamicObjetivo}</span>
                                <Field name="objetivo" label="Objetivo" length={this.state.valMaxObjetivo} onChange={this.countCaractereObjetivo.bind(this)} component={renderFieldTextArea}/>
                                </div>
                            </div>
                            <span className="count pull-right">{this.state.countDinamicRecompensa && this.state.countDinamicRecompensa}</span>
                            <Field name="txt_recompensa" label="Recompensa" length={this.state.valMaxRecompensa} onChange={this.countCaractereRecompensa.bind(this)}  component={renderFieldTextArea}/>
                           
                            <div className="row">
                                <div className="col-md-6">
                                    <Field label="Data Ínicio*" minData={moment()} component={renderDatePicker} name="tar_data_inicio" onChange={this.dataInicioChange.bind(this)}/>
                                </div>
                                <div className="col-md-6">
                                    <Field label="Data Fim*" minData={this.state.dataInicio} component={renderDatePicker} habilitar={this.state.habilitarFim} name="tar_data_fim" onChange={this.dataFimChange.bind(this)}/>
                                </div>
                            </div>
                            <hr/>                            
                            <div className="form-group">
                                <label className="control-label">Missão em equipe?*</label>
                                <Field name="flag_equipe" type="radio" onChange={this.checkActionEquipe.bind(this)} component={renderFieldRadio} value="1" label="Sim" />
                                <Field name="flag_equipe" type="radio"onChange={this.checkActionEquipe.bind(this)} component={renderFieldRadio} value="0" label="Não (Individual)" />
                            </div>
                            {this.state.statusCheckEquipe}
                        
                            {!this.state.load ? <FlashCarregando/> : this.renderListaTurmas() }

                            <hr/>
                            <div className="form-group">
                                <label className="control-label">Aluno Enviará Resposta (PDF, RAR ou ZIP)?*</label>
                                <Field name="tar_flag_resposta" type="radio" component={renderFieldRadio} onChange={this.addCampoSelecaoResposta.bind(this)} value="1" label="Sim" />
                                <Field name="tar_flag_resposta" type="radio" component={renderFieldRadio} onChange={this.addCampoSelecaoResposta.bind(this)} value="0" label="Não" />
                            </div>
                            <hr/>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="control-label">Adicionar Mídia?</label>
                                        <Field name="tipo_midia" type="radio" component={renderFieldRadio} onChange={this.addCampoMidia.bind(this)} value="0" label="Nenhuma"/>
                                        <Field name="tipo_midia" type="radio" component={renderFieldRadio} onChange={this.addCampoMidia.bind(this)} value="1" label="Imagem"/>
                                        <Field name="tipo_midia" type="radio" component={renderFieldRadio} onChange={this.addCampoMidia.bind(this)} value="2" label="Vídeo"/>
                                    </div> 
                                </div>
                                <div className="col-md-6">
                                    {this.state.opcao_tipo_midia > 0 ? this.state.midia : ""}
                                    {this.state.selectFilesMidia ? this.state.selectFilesMidia : ""}
                                </div>
                            </div>                                
                            <hr/>
                            <div className="form-group">
                                <Field 
                                     label="Anexar Item de Missão (Opcional)" 
                                     textField="Selecionar Arquivo" 
                                     component={renderFiles} 
                                     name="tar_file" 
                                     accept=".pdf,.zip,.rar,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx"                                    
                                     funcao={this.onDrop.bind(this)} />
                                {this.state.selectFiles}
                            </div> 
                            <a href={void(0)} onClick={() =>this.props.history.goBack()} className="btn btn-sm  btn-primary">Voltar</a>
                            <button type="submit" disabled={this.state.buttonDisabled} className="btn btn-primary btn-sm pull-right">Salvar</button>
                        </form>
                    </div>
                </div>
            </div>
            
        );
    }
}

const afterSubmit = (result, dispatch) => dispatch(reset('tarefa_form'));
function mapStateToProps(state){

    return {
             session     : state.auth.session,
             curso       : state.turmaReducer.allRankingCurso,
             turma       : state.tarefaReducer.all_turma_professor,
             ListaTurmas : state.turmaReducer.allProfessorTurma,
             all_equipe_disciplina : state.tarefaReducer.all_disciplinas_tarefas, 
             menu                  : state.configReducer.menu
           }
}

export default reduxForm({
  form                     : 'tarefa_form',
  destroyOnUnmount         : true,
  forceUnregisterOnUnmount : true,
  onSubmitSuccess          : afterSubmit,
  validate
})(connect(mapStateToProps, {
                              SetCadastroTarefas,
                              SetUploadFilesMidia,
                              SetUploadFiles,
                              GetTurmasCoordenador,
                              GetListaMenuTopo,
                              GetDisciplinasPerfil,
                              GetListaSubMenuTopo,
                              SetValidUrlYoutube,
                              ClearUrl,
                              SetError
                             })(TarefaProfessorCadastro));


                            //  maxSize={5242880} 
                            // maxSize={2097152} 


// WEBPACK FOOTER //
// ./src/components/professor/missoes/missao_cadastro.js